import { toast } from 'react-toastify';

/**
 * Checks form validity; if invalid, shows a toast and scrolls/focuses the first invalid field.
 * @param {HTMLFormElement} formElement – the `<form>` DOM node
 * @param {React.Dispatch<React.SetStateAction<boolean>>} setShowFormErrors – state setter to display error styles
 * @param {string} [message] – optional custom toast message
 * @returns {boolean} – true if form is valid; false otherwise
 */
export function validateAndScroll(
  formElement,
  setShowFormErrors,
  message = 'Please fill out all required fields.'
) {
  if (!formElement.checkValidity()) {
    setShowFormErrors(true);
    toast.info(message, { autoClose: 10000 });

    const firstInvalid = formElement.querySelector(':invalid');
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalid.focus();
    }
    return false;
  }

  setShowFormErrors(false);
  return true;
}
